import { BLOGGER_STAGE_ORDER } from '@ayub/shared'
import type { BloggerStageCounts } from '@ayub/shared'
import { formatNumber } from '@ayub/shared'
import { cn } from '@/lib/utils'
import { STAGE_ALL } from './hooks'
import type { StageFilter } from './hooks'
import { STAGE_CHIP_LABELS } from './stageMeta'

interface BloggerStageChipsProps {
  value: StageFilter
  onChange: (stage: StageFilter) => void
  counts: BloggerStageCounts | undefined
  isLoading: boolean
}

/**
 * Tez filtr chiplari — `docs/03-app-flow.md` Sahifa 3: "Hammasi (487) · Yangi ariza (5) ·
 * Faol (442) · Rad (31) · Blok (9)".
 */
export function BloggerStageChips({ value, onChange, counts, isLoading }: BloggerStageChipsProps) {
  const total = counts
    ? BLOGGER_STAGE_ORDER.reduce((sum, stage) => sum + counts[stage], 0)
    : undefined

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Bosqich bo'yicha filtr">
      <Chip
        label="Hammasi"
        count={total}
        isLoading={isLoading}
        active={value === STAGE_ALL}
        onClick={() => onChange(STAGE_ALL)}
      />
      {BLOGGER_STAGE_ORDER.map((stage) => (
        <Chip
          key={stage}
          label={STAGE_CHIP_LABELS[stage]}
          count={counts?.[stage]}
          isLoading={isLoading}
          active={value === stage}
          onClick={() => onChange(stage)}
        />
      ))}
    </div>
  )
}

function Chip({
  label,
  count,
  isLoading,
  active,
  onClick,
}: {
  label: string
  count: number | undefined
  isLoading: boolean
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'inline-flex h-9 items-center gap-1.5 rounded-badge border px-3 text-sm font-medium transition-colors duration-150 ease-out',
        active
          ? 'border-brand bg-brand-subtle text-brand'
          : 'border-app-border text-app-hint hover:text-app-text',
      )}
    >
      {label}
      <span className="tabular text-xs opacity-80">
        {isLoading || count === undefined ? '…' : `(${formatNumber(count)})`}
      </span>
    </button>
  )
}
